import { DocumentFiltersOperator } from 'src/api-new/bifrost';

export enum DocumentFiltersOperatorUIOnly {
  None = 'none',
}

export type FiltersOperator = DocumentFiltersOperator | DocumentFiltersOperatorUIOnly;
